import { instance } from '../instance'

/**
 * Delete report
 *
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */

export const deleteReport = async (id) => {
  return instance.delete(`/v2/wallet/report/${id}`)
}
